// extracted by mini-css-extract-plugin
export default {"virtual":"Virtual_virtual__vP47f","left":"Virtual_left__F6jDo","wrapper":"Virtual_wrapper__NjYSO"};